/**
 * 使用簿の集計期間表示。
 * バックエンド `resolveReportPeriodStart` / ローカル `sampleLocalUsageLedger` と同じく
 * 基準日の暦年 −1（`setFullYear`）を使う（date-fns `subYears` とは閏日でズレうるため）。
 */

function toYmd(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

function ymdToSlash(ymd: string): string {
  return ymd.replace(/-/g, '/');
}

export type UsageLedgerPeriodLabels = {
  periodStartYmd: string;
  periodEndYmd: string;
  periodStartLabel: string;
  periodEndLabel: string;
};

/** `YYYY-MM-DD` 基準日 → 集計開始・終了（表示は `YYYY/MM/DD`） */
export function resolveUsageLedgerPeriodLabels(baseDateYmd: string): UsageLedgerPeriodLabels {
  const trimmed = baseDateYmd.trim();
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(trimmed);
  if (!m) {
    const fallback = ymdToSlash(trimmed).slice(0, 10) || trimmed;
    return {
      periodStartYmd: trimmed,
      periodEndYmd: trimmed,
      periodStartLabel: fallback,
      periodEndLabel: fallback,
    };
  }

  const end = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  const start = new Date(end.getTime());
  start.setFullYear(start.getFullYear() - 1);

  const periodEndYmd = toYmd(end);
  const periodStartYmd = toYmd(start);
  return {
    periodStartYmd,
    periodEndYmd,
    periodStartLabel: ymdToSlash(periodStartYmd),
    periodEndLabel: ymdToSlash(periodEndYmd),
  };
}
